<div class="flex-style" style="font-size: 0.2rem;">
    <!-- 返回按钮 -->
    <svg *ngIf="showBackBtn" class="back" (click)="clickBack()"
        id="smart-assistant-gif-container-back-btn" >
        <use xlink:href="#app-icon-smart-assistant-back"></use>
    </svg>
    <!-- 小标题 -->
    <span id="smart-assistant-gif-container-sub-title" nTextTips class="sub-title">{{subTitle}}</span>
</div>

<!-- 轮播图 -->
<div class="gif-container mt-8" (mouseover)="stopAutoPlay()" (mouseout)="restartAutoPlay()">
    <div class="gif-container-gif">
        <!-- 按钮 -->
        <svg id="gif-left-btn" class="icon gif-container-left-btn" (click)="gifBtnClick(ArrowE.left)">
            <use xlink:href="#app-icon-left"></use>
        </svg>
        <svg id="gif-right-btn" class="icon gif-container-right-btn"(click)="gifBtnClick(ArrowE.right)">
            <use xlink:href="#app-icon-right"></use>
        </svg>
        <!-- 动图 -->
        <div class="background-outer">
            <img #gifEls *ngFor="let gif of gifTips; index as i"
                class="background-inner"
                [src]="getImageUrl | fn :i"
                [style.opacity]="i === currentIndex ? 1 : 0">
        </div>
    </div>
    <span id="gif-container-info" class="sub gif-container-info" [style.height]="tipMaxHeight">{{displayTip}}</span>
    <hr class="smart-assistant-line-style" style="margin: 0.24rem 0;"/>
</div>
